import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import classnames from 'classnames';
import { HtmlStringRenderer } from 'components/HtmlStringRenderer';
import ArrowDown from 'ui/Icons/keyboard_arrow_down.component.svg';
import { SvgIcon } from 'ui/SvgIcon';

interface IExpandableAreaProps {
  title: string;
  children: React.ReactNode;
  wrapperClassName?: string;
  containerClassName?: string;
  titleClassName?: string;
  contentClassName?: string;
  titleRowClassName?: string;
}

export const ExpandableArea: React.FC<IExpandableAreaProps> = props => {
  const [isExpanded, setIsExpanded] = useState(false);

  const containerClassName = classnames('expandable-area-container py-[5px] px-[32px]', props.containerClassName);
  const contentClassName = classnames('expandable-area-content mt-[5px]', props.contentClassName);
  const titleClassName = classnames(
    'expandable-area-title cursor-pointer font-hurmegeometric-sans text-[13px] text-brown-prime underline hover:no-underline',
    props.titleClassName
  );
  const titleRowClassName = classnames('title-row flex items-center cursor-pointer gap-[5px]', props.titleRowClassName);

  return (
    <div className={containerClassName}>
      <div
        className={titleRowClassName}
        onClick={() => setIsExpanded(value => !value)}
      >
        <span className={titleClassName}>{props.title}</span>
        <SvgIcon
          IconComponent={ArrowDown}
          className={classnames('transition-transform w-[14px] fill-brown-prime stroke-1', {
            'rotate-180': isExpanded,
          })}
        />
      </div>
      <AnimateHeight duration={300} height={isExpanded ? 'auto' : 0} className={classnames('accordion-area ', {})}>
        <div className={contentClassName}>
          {props.children}
        </div>
      </AnimateHeight>
    </div>
  );
};
